import React, { useEffect, useMemo, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { generateSeries } from '../../services/retirementPlanning';

const generateOptions = ({ ageRange }: { ageRange: number[] }) => ({
  chart: {
    height: 350,
    stacked: true,
    toolbar: {
      show: false,
    },

    zoom: {
      enabled: false,
    },
  },

  responsive: [
    {
      breakpoint: 480,
      options: {
        legend: {
          position: 'bottom',
          offsetX: -10,
          offsetY: 0,
        },
      },
    },
  ],
  plotOptions: {
    bar: {
      horizontal: false,
    },
  },
  xaxis: {
    categories: ageRange,
    tickAmount: 8,
    title: {
      text: 'Your Age',
      style: {
        fontFamily: 'Roboto',
        fontWeight: '400',
        color: '#777777',
      },
    },
  },
  yaxis: {
    title: {
      text: '',
    },
    tickAmount: 8,
    labels: {
      formatter: function(a: any) {
        return `$${a.toLocaleString()}`;
      },
    },
  },
  legend: {
    show: true,
    offsetX: 20,
    offsetY: 10,
    itemMargin: {
      horizontal: 10,
      vertical: 5,
    },
  },
  fill: {
    opacity: 0.5,
  },
  colors: [
    '#2268E2',
    '#78AFF6',
    '#F93B1D',
    '#10A84A',
    '#FCCE00',
    '#B58D00',
    '#9DB4C0',
  ],
  tooltip: {
    enabled: false,
  },
  dataLabels: {
    enabled: false,
  },
});

const MultipleColumnsChart = (
  {
    cAge,
    ageRange,
    iROR,
    iEECont,
    iRetAge,
    c401k,
    cHSA,
    cPS,
    cPay,
    SScal,
    iIncRep,
    Inf,
  }: {
    cAge: number,
    ageRange: number[],
    iROR: number,
    iEECont: number,
    iRetAge: number,
    c401k: number,
    cHSA: number,
    cPS: number,
    cPay: number,
    SScal: number,
    iIncRep: number,
    Inf: number
  }) => {
  const [series, setSeries] = useState<any>([]);

  useEffect(() => {
    const _to = setTimeout(() => {
      setSeries(generateSeries({
        chartType: 'bar',
        ageRange,
        iROR,
        iEECont,
        iRetAge,
        cAge,
        cHSA,
        c401k,
        cPS,
        cPay,
        SScal,
        iIncRep,
        Inf,
      }));
    }, 500);
    
    return () => {
      clearTimeout(_to);
    };
  }, [ageRange, iROR, iEECont, iRetAge, cAge, cHSA, c401k, cPS, cPay, SScal, iIncRep, Inf]);

  const options = useMemo(() => generateOptions({ ageRange }), [ageRange]);

  return (
    <div id="chart">
      <ReactApexChart
        options={options}
        legend="bottom"
        series={series}
        type="bar"
        height={350}
      />
    </div>
  );
};

export default MultipleColumnsChart;
